import {
  POST_CELL_SETTINGS_REQUEST,
  POST_CELL_SETTINGS_SUCCESS,
  POST_CELL_SETTINGS_ERROR,
  GET_SETTINGS_REQUEST,
  GET_SETTINGS_SUCCESS,
  GET_SETTINGS_ERROR,
  POST_SETTINGS_REQUEST,
  POST_SETTINGS_SUCCESS,
  POST_SETTINGS_ERROR,
} from './constants';

export const postCellSettingsRequest = (body: any) => ({
  type: POST_CELL_SETTINGS_REQUEST,
  payload: body,
});

export const postCellSettingsSuccess = () => ({
  type: POST_CELL_SETTINGS_SUCCESS,
});

export const postCellSettingsError = (error: Error | null) => ({
  type: POST_CELL_SETTINGS_ERROR,
  payload: { error },
});

export const getSettingsRequest = () => ({
  type: GET_SETTINGS_REQUEST,
});

export const getSettingsSuccess = (body: any) => ({
  type: GET_SETTINGS_SUCCESS,
  payload: body,
});

export const getSettingsError = (error: Error | null) => ({
  type: GET_SETTINGS_ERROR,
  payload: { error },
});

export const postSettingsRequest = (body: any) => ({
  type: POST_SETTINGS_REQUEST,
  payload: body,
});

export const postSettingsSuccess = () => ({
  type: POST_SETTINGS_SUCCESS,
});

export const postSettingsError = (error: Error | null) => ({
  type: POST_SETTINGS_ERROR,
  payload: { error },
});

export type Actions =
  | ReturnType<typeof postSettingsRequest>
  | ReturnType<typeof postSettingsSuccess>
  | ReturnType<typeof postSettingsError>
  | ReturnType<typeof getSettingsRequest>
  | ReturnType<typeof getSettingsSuccess>
  | ReturnType<typeof getSettingsError>
  | ReturnType<typeof postCellSettingsRequest>
  | ReturnType<typeof postCellSettingsSuccess>
  | ReturnType<typeof postCellSettingsError>;
